export const Database = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M27 25C27 26.6569 22.0751 28 16 28C9.92487 28 5 26.6569 5 25" stroke="currentColor" stroke-width="2"/>
<path d="M27 15C27 16.6569 22.0751 18 16 18C9.92487 18 5 16.6569 5 15" stroke="currentColor" stroke-width="2"/>
<path d="M27 7V25" stroke="currentColor" stroke-width="2"/>
<path d="M5 7V25" stroke="currentColor" stroke-width="2"/>
<ellipse cx="16" cy="7" rx="11" ry="3" stroke="currentColor" stroke-width="2"/>
</svg>`;
